// extracted by mini-css-extract-plugin
module.exports = {"month":"CalendarIcon_month__3w9uq","past":"CalendarIcon_past__1bW-h","date":"CalendarIcon_date__2N2VA","day":"CalendarIcon_day__2S4XP"};